import { Config } from "../../../api/config";
export var ServiceEstimateKeys = {
    Paging: "serviceEstimatePaging",
    PartList: "partList"
};
export var getEstimateListUrl = "".concat(Config.baseURL, "Estimate/Paging");
export var getPartListUrl = "".concat(Config.baseURL, "Product/PartList");
